import React from 'react'
import { FormattedMessage } from 'react-intl'

export const LOADING_DATA = (
    <FormattedMessage
        id="clanmanagement.loading.data"
        defaultMessage="Загрузка содержимого..."
    />
)



// WEBPACK FOOTER //
// ./state/actions/CMT/translations.js